module.exports = __webpack_public_path__ + "static/media/hero-interior-side.fdc8bcce.jpg";